<template>
    <div  class="flex w-full  items-baseline  lg:space-x-8 lg:items-start p-2">
        <div :class="['rounded-xl w-full lg:w-auto  items-center hidden lg:block relative shadow' , expanded ? 'lg:rounded-none lg:rounded-t-xl' : '']"  :style="[ `background-color:${selectedCategoryColor}`]">
            <div @click="expanded = !expanded" class="flex  items-center p-3 justify-between lg:w-80" >
                <div class="flex space-x-4 items-center" >
                    <component :is="selectedCategoryIcon" class="w-8 h-8" />
                    <h3 class="whitespace-nowrap text-2xl font-semibold">{{ selectedCategoryLabel }}</h3>
                </div>
                <button  class="w-6 h-6 flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-full h-full" fill="currentColor" viewBox="0 96 960 960">
                        <path v-if="expanded" class="" d="m296 711-56-56 240-240 240 240-56 56-184-184-184 184Z"/>
                        <path v-else class="" d="M480 711 240 471l56-56 184 184 184-184 56 56-240 240Z"/>
                    </svg>
                </button>
            </div>

            <div v-if="expanded" class="rounded-b-lg overflow-hidden absolute top-14 left-0 z-10">
                <div  v-for="option in options" :key="option.name">
                    <button @click="selectedCategoryName = option.name" v-if="option.name != selectedCategoryName" class="flex space-x-4 items-center p-3 border-t border-white w-full lg:w-80" :style="[ `background-color:${option.color}`]">
                        <component :is="option.iconComponent" class="w-8 h-8" />
                        <h3 class="whitespace-nowrap text-2xl">{{ option.label }}</h3>
                    </button>
                </div>

            </div>
        
        </div>

        <div class="lg:hidden w-full overflow-hidden rounded-lg" :style="[ `background-color:${selectedCategoryColor}`]">
            <div class="grid grid-cols-4 w-full  ">
                <button @click="selectedCategoryName = option.name" v-for="(option, key) in options" :key="option.name" :class="['w-full h-full p-3 flex items-center justify-center overflow-hidden', isNextOption(option) ? 'rounded-bl-lg' : '', isPreviousOption(option) ? 'rounded-br-lg' : '']" :style="[`background-color: ${option.color}`]">
                    <component :is="option.iconComponent" class="w-6 h-6"  />
                </button>
            </div>
            <div class="w-full  p-4" >
                <h3 class="text-xl font-semibold ">{{ selectedCategoryLabel }}</h3>

                <AisRefinementList :attribute="selectedCategoryAlgoliaAttribute"  :limit="30" :sortBy="sortByName">
                    <template v-slot:item="{ item, refine }">
                        <div :class="['flex mr-2', nestCount(item.label) == 1 ? 'mt-2 mb-1' : '', nestCount(item.label) == 2 ? 'mt-2 mb-1' : '', nestCount(item.label) == 3 ? 'mt-2 mb-1' : '']" :style="{marginLeft : `${nestCount(item.label) - 1}rem`   }">
                            <div class="flex space-x-2 items-center ">
                                <input
                                    
                                    type="checkbox"
                                    class="rounded bg-transparent mt-[2px] checked:text-primary-500 focus:outline-primary-500 w-6 h-6"
                                    :id="item.label"
                                    :value="item.label"
                                    :checked="item.isRefined"
                                    @input="refine($event.target.value)"
                                />
                                <span :class="['text-lg']"  >{{ getLeafItem(item.label) }} <span class="">({{ item.count }})</span></span>

                            </div>
                        </div>
                    </template>
                </AisRefinementList>
            </div>
        </div>
        <div class="hidden lg:flex w-full lg:mt-2">
            <div>
                <AisRefinementList :attribute="selectedCategoryAlgoliaAttribute" :limit="30" :sortBy="sortByName"  >
                    <template v-slot:default="{ items, refine,createURL }">
                        <div  class="flex space-x-8">
                            <button @click="() => {refine(item.value);}" v-for="item in items" class="flex space-x-2 items-center py-2 px-4 rounded-xl flex-shrink-0 whitespace-nowrap  group " :style="[ item.isRefined ? `background-color:${selectedCategoryColor}` : `background-color:${selectedCategoryColorDim}`]">
                                <div class="flex items-center space-x-2">
                                    <span class=" text-xs bg-neutral-500 text-white rounded-full w-4 h-4">{{ item.count }}</span>
                                    <span class="duration-150 capitalize text-xl ">{{ item.value }} </span>
                                </div>
                                <button v-if="item.isRefined" class="hover:text-primary-500 duration-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </button>
                            </button>



                        </div>
               
                        
                            
                    </template>

                    
                </AisRefinementList>
            </div>
        </div>
    </div>
</template>

<script>
import { AisRefinementList, AisClearRefinements, AisCurrentRefinements} from 'vue-instantsearch/vue3/es';

import GradeCategoryIcon from './GradeCategoryIcon';
import SubjectCategoryIcon from './SubjectCategoryIcon';
import SeasonalCategoryIcon from './SeasonalCategoryIcon';
import ClimateBasicsCategoryIcon from './ClimateBasicsCategoryIcon';

import {getLeafItem, nestCount} from '../utils/NestedItemsUtils'


export default {
    components:{
        AisRefinementList,
        AisClearRefinements,
        AisCurrentRefinements,
        GradeCategoryIcon,
        SubjectCategoryIcon,
        SeasonalCategoryIcon,
        ClimateBasicsCategoryIcon

    },
    props:{
        modelValue : {
            type : String,
            default : 'grades'
        },
        options : {
            type : Array,
            default : [
                {
                    name : 'grade',
                    label : 'By Grade',
                    color : '#A4EBA2',
                    colorDim : '#E8FAE8',
                    algoliaAttribute : 'gradesSegments',
                    iconComponent : GradeCategoryIcon
                },
                {
                    name : 'subject',
                    label : 'By Subject',
                    color : '#95D2F2',
                    colorDim : '#E4F4FC',
                    algoliaAttribute : 'subjects',

                    iconComponent : SubjectCategoryIcon
                },
                {
                    name : 'climate-basics',
                    label : 'Climate Basics',
                    color : '#FDBA74',
                    colorDim : '#FFE8DB',

                    algoliaAttribute : 'climateBasics',

                    iconComponent : ClimateBasicsCategoryIcon
                },
                {
                    name : 'seasonal',
                    label : 'Seasonal',
                    color : '#C4B5FD',
                    colorDim : '#FFE8DB',

                    algoliaAttribute : 'seasonals',

                    iconComponent : SeasonalCategoryIcon
                }
                
            ]
        }
    },
    data(){
        return {
            expanded : false
        }
    },
    watch:{
        selectedCategoryName(v){
            this.expanded = false
            console.log('changed', v)
        }
    },
    computed:{
        selectedCategoryName:{
            get(){
                return this.modelValue;
            },
            set(value){
                this.$emit('update:modelValue', value)
            }
        },
        selectedCategoryOption(){
            return this.options.filter(option => option.name == this.selectedCategoryName)[0] ?? {}
        },
        selectedCategoryLabel(){
            return this.selectedCategoryOption.label
        },
        selectedCategoryIcon(){
            return this.selectedCategoryOption.iconComponent
        },
        selectedCategoryColor(){
            return this.selectedCategoryOption.color
        },
        selectedCategoryColorDim(){
            return this.selectedCategoryOption.colorDim
        },
        selectedCategoryAlgoliaAttribute(){
            return this.selectedCategoryOption.algoliaAttribute
        }
    },
    methods:{
        //Returns true if the given option is the next option after the selected option
        isNextOption(option){
            let optionIndex = this.options.findIndex(o => o.name == option.name)
            let selectedOptionIndex = this.options.findIndex(o => o.name == this.selectedCategoryOption.name)
            return optionIndex == selectedOptionIndex + 1

        },
        // Returns true if the given option is the previous option before the selected option
        isPreviousOption(option){
            let optionIndex = this.options.findIndex(o => o.name == option.name)
            let selectedOptionIndex = this.options.findIndex(o => o.name == this.selectedCategoryOption.name)
            return optionIndex == selectedOptionIndex - 1
        },
        sortByName(a,b){
            if ( a.name[0] == 'K' || a.name < b.name) return -1;
            if ( a.name > b.name) return 1;
            return 0;
        }

    },
    setup(){
        return {
            nestCount,
            getLeafItem
        }
    }
}
</script>